import axios from "axios";
import { CommonTexts as Texts } from "../helpers/LayoutTexts";
import { StateDegree } from "../models/StateDegree";

export async function getStateUniversities(adminId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "state-degrees/universities-by-admin", {   
            headers: {
                'Authorization' : `Bearer ${token}`
            },         
            params: {                
                adminId: adminId
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getStateFaculties(universityId: number = -1, adminId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "state-degrees/faculties-by-admin", {   
            headers: {
                'Authorization' : `Bearer ${token}`
            },         
            params: {                
                universityId: universityId,                
                adminId: adminId
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getStateDegrees(universityId: number = -1, facultyId: number = -1, keyword: string = "", adminId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "state-degrees/degrees-by-admin", {   
            headers: {
                'Authorization' : `Bearer ${token}`
            },         
            params: {                
                universityId: universityId,
                facultyId: facultyId,
                keyword: keyword,
                adminId: adminId
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getStateDegree(degreeId: number, adminId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "state-degrees/degree-by-admin", {   
            headers: {
                'Authorization' : `Bearer ${token}`
            },         
            params: {                
                degreeId: degreeId,
                adminId: adminId
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function editStateDegree(degree: StateDegree, adminId: number, token: string) {          
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(Texts.apiBaseUrl + "state-degrees/degree-edit-by-admin", degree, {
            headers: {
              'Content-Type': 'application/json',              
              'Authorization' : `Bearer ${token}`
            },
            params: {
                adminId: adminId
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}